<template>
    <div>
      <!-- ... [unchanged header/layout code] ... -->
  
      <div class="form-group col-md-6">
        <button type="button" class="btn btn-primary" @click="toggleImageSelect()">
          Upload Media
        </button>
        <div class="clearfix"></div>
        <small class="form-text text-muted" v-if="!gallary_path">
          Select image file from gallery.
        </small>
        <small class="form-text text-danger" v-if="errors.has('gallary_id')" v-text="errors.get('gallary_id')"></small>
  
        <img v-if="gallary_path" :src="cdnUrl(gallary_path)" style="width: 100px; height: 100px" />
      </div>
  
      <div class="form-group col-md-6">
        <small class="form-text text-muted mb-2">The offer itself (for example <strong>10% OFF</strong>) is shown in big red letters above these titles, straight from the amount below. Type <code>{offer}</code> in a title to repeat it, e.g. "Get {offer} your first order" shows "Get {{ offerLabel }} your first order".</small>
        <label class="text-dark">First Title</label>
        <input type="text" class="form-control" v-model="popup.first_title">
        <small class="form-text text-danger" v-if="errors.has('first_title')" v-text="errors.get('first_title')"></small>
      </div>
  
      <div class="form-group col-md-6">
        <label class="text-dark">Second Title</label>
        <input type="text" class="form-control" v-model="popup.second_title">
        <small class="form-text text-danger" v-if="errors.has('second_title')" v-text="errors.get('second_title')"></small>
      </div>
  
      <div class="form-group col-md-6">
        <label class="text-dark">Third Title</label>
        <input type="text" class="form-control" v-model="popup.third_title">
        <small class="form-text text-danger" v-if="errors.has('third_title')" v-text="errors.get('third_title')"></small>
      </div>
  
      <div class="col-md-6">
                <div class="form-group">
                  <label class="text-dark">Status *</label>
                  <select v-model="popup.status" class="form-control" required>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                  <small class="form-text text-danger" v-if="errors.has('status')">
                    {{ errors.get('status') }}
                  </small>
                </div>
              </div>
            
      <div class="col-md-12 mt-4">
        <h5 class="text-dark">Welcome coupon</h5>
        <small class="form-text text-muted">Every email entered in the popup (or the add-to-cart offer) gets its own single-use code, shown on screen and applied automatically at checkout. See who asked and who used it under Sell / Orders &gt; Coupon Leads.</small>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">Offer</label>
        <select v-model="popup.coupon_enabled" class="form-control">
          <option :value="true">On - give each email a coupon</option>
          <option :value="false">Off</option>
        </select>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">Also email the code to the customer</label>
        <select v-model="popup.coupon_send_email" class="form-control">
          <option :value="false">No - show it on screen only</option>
          <option :value="true">Yes</option>
        </select>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">Discount type</label>
        <select v-model="popup.coupon_type" class="form-control">
          <option value="percentage">Percentage (%)</option>
          <option value="fixed">Fixed amount ($)</option>
        </select>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">Amount</label>
        <input type="number" min="1" step="0.01" class="form-control" v-model="popup.coupon_amount">
        <small class="form-text text-danger" v-if="errors.has('coupon_amount')" v-text="errors.get('coupon_amount')"></small>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">Valid for (days)</label>
        <input type="number" min="1" max="365" class="form-control" v-model="popup.coupon_valid_days">
        <small class="form-text text-danger" v-if="errors.has('coupon_valid_days')" v-text="errors.get('coupon_valid_days')"></small>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">Sale items</label>
        <select v-model="popup.coupon_exclude_sale_items" class="form-control">
          <option :value="true">Not on items already on sale</option>
          <option :value="false">On every item</option>
        </select>
      </div>

      <div class="col-md-12 mt-4">
        <h5 class="text-dark">When it shows up</h5>
        <small class="form-text text-muted">It opens by itself on the website after the seconds below. If the visitor closes it, it stays away for the number of days below; once they got their code it never opens by itself again.</small>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">Show after (seconds)</label>
        <input type="number" min="0" max="300" class="form-control" v-model="popup.delay_seconds">
        <small class="form-text text-muted">0 = as soon as the page opens.</small>
        <small class="form-text text-danger" v-if="errors.has('delay_seconds')" v-text="errors.get('delay_seconds')"></small>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">Show again after closing (days)</label>
        <input type="number" min="0" max="365" class="form-control" v-model="popup.reshow_days">
        <small class="form-text text-muted">0 = on every page they open.</small>
        <small class="form-text text-danger" v-if="errors.has('reshow_days')" v-text="errors.get('reshow_days')"></small>
      </div>

      <div class="form-group col-md-3">
        <label class="text-dark">"Get {{ offerLabel }}" tab in the corner</label>
        <select v-model="popup.show_tab" class="form-control">
          <option :value="true">Show - visitors can reopen the offer</option>
          <option :value="false">Hide</option>
        </select>
      </div>

      <div class="form-group col-md-12">
        <a href="/?popup=preview" target="_blank" rel="noopener" class="btn btn-outline-primary">See it on the homepage</a>
        <small class="form-text text-muted">Opens the homepage with the popup right away (save first). Visitors see it after the seconds above.</small>
        <small class="form-text text-warning" v-if="String(popup.status) !== '1' || !popup.coupon_enabled">The popup is off: set Status to Active and Offer to On to show it on the website.</small>
      </div>

      <!-- ... -->
      <button type="button" @click="addUpdateHome()" class="btn btn-primary" style="margin-top: 30px">
        Submit
      </button>
  
      <attach-image @toggleImageSelect="toggleImageSelect" :showModal="showModal1" @setImage="setImage" />
    </div>
  </template>
  

<script>
import ErrorHandling from "../../ErrorHandling";
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      popup: {
        gallary_id: '',
        first_title: '',
        second_title: '',
        third_title: '',
        status: 1,
        coupon_enabled: true,
        coupon_send_email: false,
        coupon_type: 'percentage',
        coupon_amount: 10,
        coupon_valid_days: 14,
        coupon_exclude_sale_items: true,
        delay_seconds: 15,
        reshow_days: 3,
        show_tab: true,
      },
      showModal1: false,
      gallary_path: "",
      errors: new ErrorHandling(),
      token: [],
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
    };
  },

  computed: {
    // same wording as the website (LeadCouponService::label)
    offerLabel() {
      const amount = parseFloat(this.popup.coupon_amount) || 10;
      const text = String(+amount.toFixed(2));
      return this.popup.coupon_type === 'fixed' ? '$' + text + ' off' : text + '% off';
    },
  },

  methods: {
    fetchPopup() {
      this.$parent.loading = true;
      axios.get("/api/admin/popup-info-setting", this.token)
        .then((res) => {
          this.popup = {
            gallary_id: res.data.data.gallary_id?.id || '',
            first_title: res.data.data.first_title,
            second_title: res.data.data.second_title,
            third_title: res.data.data.third_title,
            status: res.data.data.status,
            coupon_enabled: res.data.data.coupon_enabled !== false,
            coupon_send_email: res.data.data.coupon_send_email === true,
            coupon_type: res.data.data.coupon_type || 'percentage',
            coupon_amount: res.data.data.coupon_amount || 10,
            coupon_valid_days: res.data.data.coupon_valid_days || 14,
            coupon_exclude_sale_items: res.data.data.coupon_exclude_sale_items !== false,
            delay_seconds: res.data.data.delay_seconds ?? 15,
            reshow_days: res.data.data.reshow_days ?? 3,
            show_tab: res.data.data.show_tab !== false,
          };
          this.gallary_path = res.data.data.gallary_id?.gallary_detail[0]?.path || '';
        })
        .finally(() => (this.$parent.loading = false));
    },

    toggleImageSelect() {
      this.showModal1 = !this.showModal1;
    },

    setImage(gallary) {
      this.gallary_path = gallary.gallary_path;
      this.popup.gallary_id = gallary.gallary_id;
    },

    addUpdateHome() {
      this.$parent.loading = true;

      axios.post("/api/admin/popup-info-setting", this.popup, this.token)
        .then((res) => {
          if (res.data.status) {
            this.$toaster.success("Settings updated successfully");
            this.fetchPopup();
          } else {
            this.$toaster.error(res.data.message);
          }
        })
        .catch((error) => {
          this.errors = new ErrorHandling();
          if (error.response.status === 422) {
            this.errors.record(error.response.data.errors || {});
          }
        })
        .finally(() => (this.$parent.loading = false));
    }
  },

  mounted() {
    const token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchPopup();
  }
};

</script>
